import { t } from 'i18next';

import { SelectionBase } from './SelectionBase';
import { SelectBoxOption } from '../stores/SelectBoxStore';
import { ProjectSettingsActions } from '../actions/ProjectSettingsActions';
import { ProjectSettingsStore } from '../stores/ProjectSettingsStore';

export class SelectionUnitOfMeasurement extends SelectionBase {
    protected showValueInApp: boolean = true;
    protected id: string = 'measurement-select';

    public componentWillMount(): void {
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.onChange();
    }

    protected onChange = (): void => {
        this.setState({
            value: ProjectSettingsStore.getState().unitOfMeasurement,
            enabled: true,
            visible: true
        });
    };

    protected getLabel(): string {
        return t('Unit of Measurement');
    }

    protected options(): Array<SelectBoxOption> {
        return [
            {key: 'm', name: 'm', className: 'egr-select-option-noicon', callback: () => { ProjectSettingsActions.setMeasurement('m'); }},
            {key: 'cm', name: 'cm', className: 'egr-select-option-noicon', callback: () => { ProjectSettingsActions.setMeasurement('cm'); }},
            {key: 'mm', name: 'mm', className: 'egr-select-option-noicon', callback: () => { ProjectSettingsActions.setMeasurement('mm'); }},
            {key: 'feet', name: 'ft', className: 'egr-select-option-noicon', callback: () => { ProjectSettingsActions.setMeasurement('feet'); }},
            {key: 'inch', name: 'in', className: 'egr-select-option-noicon', callback: () => { ProjectSettingsActions.setMeasurement('inch'); }}
        ];
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SelectionUnitOfMeasurement.tsx